export default __webpack_public_path__ + "static/media/img-bitovation-solution.7074763f.png";